export const getCalculatorCents = function(approvedAmountCents, purchaseAmountCents) {
    approvedAmountCents = approvedAmountCents || 0
    purchaseAmountCents = purchaseAmountCents || approvedAmountCents
    return Math.min(approvedAmountCents, purchaseAmountCents)
}

export const calculateEstimatedMinimumPaymentCents = function (paymentPlan, providerState, applicationState) {
    if (!paymentPlan?.providerKey) {
        return null
    }

    const offer = providerState.getPreAuthResponse(paymentPlan.providerKey)?.offers?.[0]
    const minPaymentPct = offer?.minPaymentPercent

    if (!minPaymentPct) {
        return null
    }

    const purchaseAmountCents = applicationState?.application?.purchaseAmountCents
    const creditLimitCents = offer?.creditLimitCents

    if (!purchaseAmountCents || !creditLimitCents) {
        return null
    }

    const baseAmountCents = Math.min(purchaseAmountCents, creditLimitCents)

    return Math.ceil(baseAmountCents * (minPaymentPct / 100))
}
